// extracted by mini-css-extract-plugin
export var grid = "_1n-0";
export var span1 = "_1n-2";
export var span10 = "_1n-b";
export var span10L = "_1n-z";
export var span10M = "_1n-n";
export var span10Xl = "_1n-1b";
export var span11 = "_1n-c";
export var span11L = "_1n-10";
export var span11M = "_1n-o";
export var span11Xl = "_1n-1c";
export var span12 = "_1n-d";
export var span12L = "_1n-11";
export var span12M = "_1n-p";
export var span12Xl = "_1n-1d";
export var span1L = "_1n-q";
export var span1M = "_1n-e";
export var span1Xl = "_1n-12";
export var span2 = "_1n-3";
export var span2L = "_1n-r";
export var span2M = "_1n-f";
export var span2Xl = "_1n-13";
export var span3 = "_1n-4";
export var span3L = "_1n-s";
export var span3M = "_1n-g";
export var span3Xl = "_1n-14";
export var span4 = "_1n-5";
export var span4L = "_1n-t";
export var span4M = "_1n-h";
export var span4Xl = "_1n-15";
export var span5 = "_1n-6";
export var span5L = "_1n-u";
export var span5M = "_1n-i";
export var span5Xl = "_1n-16";
export var span6 = "_1n-7";
export var span6L = "_1n-v";
export var span6M = "_1n-j";
export var span6Xl = "_1n-17";
export var span7 = "_1n-8";
export var span7L = "_1n-w";
export var span7M = "_1n-k";
export var span7Xl = "_1n-18";
export var span8 = "_1n-9";
export var span8L = "_1n-x";
export var span8M = "_1n-l";
export var span8Xl = "_1n-19";
export var span9 = "_1n-a";
export var span9L = "_1n-y";
export var span9M = "_1n-m";
export var span9Xl = "_1n-1a";
export var stretch = "_1n-1";